import type { Order } from '../types';
import { isSampleOrDemoOrderId } from './sampleOrderIds';
import { isUnpaidOnlineWebOrder } from './onlineOrderVisibility';

/**
 * Orders excluded from register close / EOD checklist (seed data, customer-checkout drafts).
 */
export function shouldIncludeOrderInRegisterCloseChecklist(order: Order): boolean {
  if (isSampleOrDemoOrderId(order.id)) return false;
  if (order.isDeleted) return false;
  if (isUnpaidOnlineWebOrder(order)) return false;
  return true;
}

export function filterOrdersForRegisterClose(orders: Order[]): Order[] {
  return orders.filter(
    (o) =>
      o.status !== 'cancelled' &&
      o.status !== 'refunded' &&
      shouldIncludeOrderInRegisterCloseChecklist(o),
  );
}
